// extracted by mini-css-extract-plugin
export default {"content_main":"content_content_main__Jj2dE","content_container":"content_content_container__Cm+Hb","content_body_container":"content_content_body_container__Fx6Nz"};